export function formatDateTime(timestampInMs) {
  if (!timestampInMs) return '';

  const date = new Date(Number(timestampInMs));

  if (isNaN(date.getTime())) return ''; 

  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}
